import { makeStyles } from '@material-ui/core/styles';

export const makeLoadingSpinnerstyles = makeStyles((theme) => ({
  'loading-spinner': {
    background: `rgba(0, 0, 0, 0.${theme.palette.type === 'light' ? 7 : 5})`,
  },
}));
